
import { useTranslation } from 'react-i18next';

export default function BrandsSection() {
  const { t } = useTranslation();
  
  const brands = [
    'Gucci', 'Prada', 'Loewe', 'Acne Studios', 
    'Balenciaga', 'Burberry', 'Jil Sander', 'Marni',
    'Rick Owens', 'Maison Margiela', 'The Row', 'Yohji Yamamoto',
    'Bottega Veneta', 'Saint Laurent', 'Celine', 'Hermès',
    'Chanel', 'Dior', 'Valentino', 'Givenchy'
  ];

  return (
    <section id="brands" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-black" style={{ fontFamily: 'Playfair Display, serif' }}>
            {t('featuredBrands')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('brandsDescription')}
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8">
          {brands.map((brand, index) => (
            <div 
              key={index} 
              className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 flex items-center justify-center min-h-24 group"
            >
              <span className="text-lg font-medium text-gray-800 group-hover:text-black transition-colors duration-300 text-center">
                {brand}
              </span>
            </div>
          ))}
        </div>
        
        <div className="mt-16 text-center">
          <div className="bg-white rounded-lg p-8 shadow-sm">
            <h3 className="text-2xl font-bold mb-4 text-black">
              Expanding Our Network
            </h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              We continuously expand our portfolio of European fashion partners to offer the most comprehensive selection of premium brands to our Chinese retail network.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <div className="flex items-center justify-center space-x-2">
                <i className="ri-star-line text-amber-600"></i>
                <span className="text-gray-700">Premium Selection</span>
              </div>
              <div className="flex items-center justify-center space-x-2">
                <i className="ri-handshake-line text-amber-600"></i>
                <span className="text-gray-700">Trusted Partnerships</span>
              </div>
              <div className="flex items-center justify-center space-x-2">
                <i className="ri-trending-up-line text-amber-600"></i>
                <span className="text-gray-700">Market Leaders</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
